import { Verify, verify, Reset, reset, getLogo, passwordLength } from '@/api/login'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
// 获取验证码
export const useVerify = () => {
  const { runAsync } = useRequest((data: Verify) => verify(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取验证码失败')
    },
  })

  return [runAsync] as const
}
// 获取logo
export const useGetLogo = () => {
  const { runAsync: run, data } = useRequest(() => getLogo(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取logo错误')
    },
  })
  return [run, data?.data] as const
}
// 修改密码
export const useReset = () => {
  const { runAsync } = useRequest((data: Reset) => reset(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '修改密码失败')
    },
  })

  return [runAsync] as const
}

export const usePasswordLength = () => {
  const { runAsync: run } = useRequest(passwordLength, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '密码配置获取失败')
    },
  })
  return [run] as const
}
